import React, { useEffect } from "react";
import { findBankByName, INDONESIAN_BANKS } from "../lib/indonesianBanks";

export default function BankSelect({ value = "", bankCode = "", onChange, className = "", required = false }) {
  const selectedBank = INDONESIAN_BANKS.find((bank) => bank.code === bankCode) || findBankByName(value);
  const selectedCode = selectedBank?.code || "";
  const isLegacyValue = value && !selectedBank;

  useEffect(() => {
    if (selectedBank && (selectedBank.code !== bankCode || selectedBank.name !== value)) onChange(selectedBank);
    // onChange is intentionally omitted: page-level callbacks are recreated on render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankCode, selectedBank?.code, selectedBank?.name, value]);

  return (
    <select
      value={selectedCode || (isLegacyValue ? `legacy:${value}` : "")}
      required={required}
      onChange={(event) => {
        const bank = INDONESIAN_BANKS.find((item) => item.code === event.target.value);
        onChange(bank || { code: "", name: "" });
      }}
      className={className}
    >
      <option value="">Pilih bank</option>
      {isLegacyValue && <option value={`legacy:${value}`}>{value} (data lama)</option>}
      {INDONESIAN_BANKS.map((bank) => (
        <option key={bank.code} value={bank.code}>{bank.name} · {bank.code}</option>
      ))}
    </select>
  );
}
